export default "__VITE_ASSET__Darp0P8o__"